<ng-container *transloco="let t">
  @if (!hasMadeChoice) {
    <div class="popup-overlay" role="dialog" aria-modal="true" aria-labelledby="dialog-title">
      <div class="popup-content">
        <!-- begin:: Main View -->
        <div class="view-main" [class.pb-0]="isCustomizing">
          <!-- begin:: Visitor Profile Section -->
          <div>
            <h3 transloco="label_visitor_profile"></h3>
            <p class="text-gray-800" transloco="paragraph_visitor_profile_message"></p>

            <!-- Cards Row -->
            <div class="row g-3 my-2">
              <!-- Private -->
              <div class="col-12 col-md-6">
                <label class="d-flex flex-column h-100 border rounded p-4 cursor-pointer" [class.border-primary]="customerType() === '1'" [class.bg-light-primary]="customerType() === '1'">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-person-fill fs-2x me-3 text-gray-700" [class.text-primary]="customerType() === '1'"></i>
                      <span class="fw-bold fs-5 text-gray-800" transloco="label_private"></span>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-0">
                      <input class="form-check-input" type="radio" name="customerType" value="1" [(ngModel)]="customerType" />
                    </div>
                  </div>
                  <div class="fs-8 text-gray-800" transloco="sentence_private_purchase_info"></div>
                </label>
              </div>

              <!-- Company / Workshop -->
              <div class="col-12 col-md-6">
                <label class="d-flex flex-column h-100 border rounded p-4 cursor-pointer" [class.border-primary]="customerType() === '2'" [class.bg-light-primary]="customerType() === '2'">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-building fs-2x me-3 text-gray-700" [class.text-primary]="customerType() === '2'"></i>
                      <span class="fw-bold fs-5 text-gray-800" transloco="label_business"></span>
                    </div>
                    <div class="form-check form-check-custom form-check-solid mb-0">
                      <input class="form-check-input" type="radio" name="customerType" value="2" [(ngModel)]="customerType" />
                    </div>
                  </div>
                  <div class="fs-8 text-gray-800" transloco="sentence_business_purchase_info"></div>
                </label>
              </div>
            </div>
          </div>
          <!-- end:: Visitor Profile Section -->

          <!-- begin::separator -->
          <div class="separator separator-dashed my-5"></div>
          <!-- end::separator -->

          @if (!isCustomizing) {
            <!-- begin:: Cookie Policy Info -->
            <h3 id="dialog-title" transloco="sentence_use_of_cookies"></h3>
            <div class="mb-2">
              <p class="text-gray-800" transloco="paragraph_use_of_cookie_message"></p>
              <p class="text-gray-800">
                <span transloco="sentence_for_more_information"></span>,
                <a href="/{{ language }}/documents/{{ t('label_url_use_of_cookies') }}" class="link-primary text-decoration-underline ms-1" transloco="sentence_see_cookie_policy"></a>
              </p>
            </div>
            <!-- end:: Cookie Policy Info -->

            <!-- begin:: Action Buttons -->
            <div class="d-block d-md-flex mt-3 gap-2">
              <button type="button" class="btn btn-primary w-100 my-1 my-md-1" (click)="onAllowAll()">
                <i class="bi bi-check-circle-fill me-1"></i>
                <span transloco="label_accept_all"></span>
              </button>
              <button type="button" class="btn btn-light-danger w-100 my-1 my-md-1" (click)="onDeny()">
                <i class="bi bi-x-circle me-1"></i>
                <span transloco="label_reject_all"></span>
              </button>
              <button type="button" class="btn btn-light-primary w-100 my-1 my-md-1" (click)="showCustomization()">
                <span transloco="label_customize"></span>
                <i class="bi bi-chevron-right ms-1"></i>
              </button>
            </div>
          }
          <!-- end:: Action Buttons -->
        </div>
        <!-- end:: Main View -->

        <!-- begin:: Cookie Settings / Customizer -->
        @if (isCustomizing) {
          <div class="view-customize">
            <div class="modal-header">
              <h3 transloco="label_cookie_settings"></h3>
              <button type="button" class="btn-close" (click)="hideCustomization()" [attr.aria-label]="t('label_close')"></button>
            </div>

            <div class="modal-body">
              @if (lastConsentDate) {
                <p class="fs-7 text-muted mb-3" transloco="dynamic_cookie_consent_date" [translocoParams]="{ value: (lastConsentDate | date: 'longDate') }"></p>
              }

              <ol class="list-group list-group-flush">
                <li class="list-group-item d-flex align-items-start justify-content-between">
                  <div class="me-2">
                    <div class="fw-bold fs-5" transloco="label_essential"></div>
                    <p class="fs-7 text-gray-800 mb-0" transloco="paragraph_essential_cookies"></p>
                  </div>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" checked disabled />
                  </div>
                </li>

                <li class="list-group-item d-flex align-items-start justify-content-between">
                  <div class="me-2">
                    <div class="fw-bold fs-5" transloco="label_technical_performance"></div>
                    <p class="fs-7 text-gray-800 mb-0" transloco="paragraph_technical_performance_cookies"></p>
                  </div>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" checked disabled />
                  </div>
                </li>

                <li class="list-group-item d-flex align-items-start justify-content-between">
                  <div class="me-2">
                    <div class="fw-bold fs-5" transloco="label_site_analytics"></div>
                    <p class="fs-7 text-gray-800 mb-0" transloco="paragraph_analytics_cookies"></p>
                  </div>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="siteAnalyticsCookie" />
                  </div>
                </li>

                <li class="list-group-item d-flex align-items-start justify-content-between">
                  <div class="me-2">
                    <div class="fw-bold fs-5" transloco="label_google_ads"></div>
                    <p class="fs-7 text-gray-800 mb-0" transloco="paragraph_google_ads_cookies"></p>
                  </div>
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" [(ngModel)]="googleAdsCookie" />
                  </div>
                </li>
              </ol>

              <!-- === Cookie inventory + policy table === -->
              <div class="mt-4">
                <div class="d-flex align-items-center justify-content-between">
                  <h4 class="mb-2" transloco="label_cookie_storage_inventory"></h4>
                </div>
                <div class="mb-3">
                  <ul class="mb-0">
                    @for (v of registry.vendors; track v.id) {
                      <li>
                        <a [href]="v.policyUrl" target="_blank" rel="noopener nofollow">{{ v.name }}</a>
                        — {{ t(v.categories) }}
                      </li>
                    }
                  </ul>
                </div>

                <div class="table-responsive">
                  <table class="table table-sm table-striped">
                    <thead class="table-light align-middle fw-semibold">
                      <tr>
                        <th style="min-width: 150px" transloco="label_pattern"></th>
                        <th transloco="label_storage"></th>
                        <th transloco="label_category"></th>
                        <th transloco="label_vendor"></th>
                        <th transloco="label_purpose" style="min-width: 200px"></th>
                        <th transloco="label_retention"></th>
                      </tr>
                    </thead>
                    <tbody class="align-middle">
                      @for (row of inventory; track row.key) {
                        <tr>
                          <td>
                            <code>{{ row.pattern || row.key }}</code>
                          </td>
                          <td>{{ row.storage }}</td>
                          <td>{{ t(row.category) }}</td>
                          <td>{{ t(row.vendorName) }}</td>
                          <td>{{ t(row.purpose) }}</td>
                          <td>{{ t(row.retention) }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- === End inventory === -->
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-light-danger me-auto" (click)="onDeny()">
                <i class="bi bi-x-circle me-1"></i>
                <span transloco="label_reject_all"></span>
              </button>

              <button type="button" class="btn btn-primary" (click)="onAllowAll()">
                <i class="bi bi-check-circle-fill me-1"></i>
                <span transloco="label_accept_all"></span>
              </button>

              <button type="button" class="btn btn-primary" (click)="onSavePreferences()">
                <i class="bi bi-floppy-fill me-1"></i>
                <span transloco="label_save_preferences"></span>
              </button>
            </div>
          </div>
        }
        <!-- end:: Cookie Settings -->
      </div>
    </div>
  } @else {
    <!-- begin:: Cookie Side Icon -->
    <div (click)="showBanner()" id="cookie-badge" tabindex="0" role="button" [attr.aria-label]="t('label_cookie_settings')">
      <svg id="cookie-badgesvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320.28 320.28">
        <g id="cs_layer_2" data-name="cs_layer_2">
          <g id="cs_layer_1" data-name="cs_layer_1">
            <path class="cookies-logo" d="M160.14,0A160.14,160.14,0,1,0,320.28,160.14,160.14,160.14,0,0,0,160.14,0Zm0,301.49A141.35,141.35,0,1,1,301.49,160.14,141.35,141.35,0,0,1,160.14,301.49Z"></path>
            <circle class="cookies-logo" cx="98.09" cy="106.52" r="35.11"></circle>
            <circle class="cookies-logo" cx="88.27" cy="200.63" r="14.09"></circle>
            <circle class="cookies-logo" cx="151.17" cy="251.06" r="22.63"></circle>
            <circle class="cookies-logo" cx="238.42" cy="180.9" r="30.49"></circle>
            <circle class="cookies-logo" cx="206.65" cy="86.27" r="18.53"></circle>
          </g>
        </g>
      </svg>
    </div>
    <!-- end:: Cookie Side Icon -->
  }
</ng-container>
